import moment from "moment";
import { branding, Colour_Tournament } from "./Utils";

export class CBManual {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "CBMANUAL";
    this.scene = "CBMANUAL";
    this.data = [];
    this.page = 7050;
  }

  async preview({ options }) {
    this.onAir = false;

    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml = Colour_Tournament({ game: options.game, xml });

      if (options.push_up) {
        xml.payload.field.find((item) => {
          return item.attr.name === "0000";
        }).value = "1";
      } else {
        xml.payload.field.find((item) => {
          return item.attr.name === "0000";
        }).value = "0";
      }

      xml.payload.field.find((item) => {
        return item.attr.name === "0004";
      }).value = options?.box?.number_rows;

      let folder = "";
      if (options?.box?.title_badge_folder === "team") {
        folder = "IMAGE*___MEDIA/RUGBY_LEAGUE/TEAM_BADGES/";
      } else if (options?.box?.title_badge_folder === "competition") {
        folder = "IMAGE*___MEDIA/RUGBY_LEAGUE/COMPETITION_LOGOS/";
      }
      xml.payload.field.find((item) => {
        return item.attr.name === "0000102";
      }).value = folder + (options?.box?.title_badge ?? "");
      xml.payload.field.find((item) => {
        return item.attr.name === "0000102";
      }).value = folder + (options?.box?.title_badge ?? "");
      xml.payload.field.find((item) => {
        return item.attr.name === "0005";
      }).value = options?.box?.show_badges ? "1" : "0";
      let lines = options?.box?.heading?.split("\n");

      xml.payload.field.find((item) => {
        return item.attr.name === "0000103";
      }).value = lines?.length > 1 ? lines?.[0] : "";
      xml.payload.field.find((item) => {
        return item.attr.name === "0000104";
      }).value = lines?.length > 1 ? lines?.[1] : lines?.[0];
      xml.payload.field.find((item) => {
        return item.attr.name === "0000106";
      }).value = options?.box?.subtitle;

      xml.payload.field.find((item) => {
        return item.attr.name === "00100";
      }).value = options?.box?.column_1;

      xml.payload.field.find((item) => {
        return item.attr.name === "00200";
      }).value = options?.box?.column_2;

      xml.payload.field.find((item) => {
        return item.attr.name === "00300";
      }).value = options?.box?.column_3;

      xml.payload.field.find((item) => {
        return item.attr.name === "00400";
      }).value = options?.box?.column_4;

      for (let r = 0; r < options?.box?.number_rows; r++) {
        xml.payload.field.find((item) => {
          return item.attr.name === "0" + (r + 1) + "0";
        }).value = options?.box?.rows?.[r]?.highlighted ? "1" : "0";
        //NOT AVAILABLE IN NEW CB
        // xml.payload.field.find((item) => {
        //   return item.attr.name === "0" + (r + 1) + "9";
        // }).value = options?.box?.rows?.[r]?.dots ? "1" : "0";
        xml.payload.field.find((item) => {
          return item.attr.name === "0" + (r + 1) + "01";
        }).value = options?.box?.rows?.[r]?.number ?? "";
        xml.payload.field.find((item) => {
          return item.attr.name === "0" + (r + 1) + "02";
        }).value = options?.box?.rows?.[r]?.text ?? "";
        xml.payload.field.find((item) => {
          return item.attr.name === "0" + (r + 1) + "03";
        }).value = options?.box?.rows?.[r]?.small_text ?? "";
        xml.payload.field.find((item) => {
          return item.attr.name === "0" + (r + 1) + "04";
        }).value = options?.box?.rows?.[r]?.col_1text ?? "";
        xml.payload.field.find((item) => {
          return item.attr.name === "0" + (r + 1) + "05";
        }).value = options?.box?.rows?.[r]?.col_2text ?? "";
        xml.payload.field.find((item) => {
          return item.attr.name === "0" + (r + 1) + "06";
        }).value = options?.box?.rows?.[r]?.col_3text ?? "";
        xml.payload.field.find((item) => {
          return item.attr.name === "0" + (r + 1) + "07";
        }).value = options?.box?.rows?.[r]?.col_4text ?? "";
        xml.payload.field.find((item) => {
          return item.attr.name === "0" + (r + 1) + "101";
        }).value = options?.box?.rows?.[r]?.badge ?? "";
      }

      await this.updateVizPage({ page: this.page, data: xml }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
